import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet';
import Header from '../../../../Components/Header';
import Footer from '../../../../Components/Footer';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import SVGCurveLine from '../../../../Hooks/SVGCurveLine'; 
import { GoNorthStar } from "react-icons/go";
import { PiSlideshow, PiStarFourFill } from "react-icons/pi";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { GoPlus } from "react-icons/go";
import starY from '../../../../Assets/Images/icons/star.webp';

import logo from "../../../../Assets/Images/logos/work/education/ryan.png"
import ourwork1 from '../../../../Assets/Images/work/ryan-group/ryangroup-main.webp';
import ourwork2 from '../../../../Assets/Images/work/ryan-group/ryanslide-1.webp';
import ourwork3 from '../../../../Assets/Images/work/ryan-group/ryanslide-2.webp';
import ourwork4 from '../../../../Assets/Images/work/ryan-group/ryanslide-3.webp';
import ourwork5 from '../../../../Assets/Images/work/ryan-group/ryanslide-4.webp';
import ourwork6 from '../../../../Assets/Images/work/ryan-group/ryanslide-5.webp';

import CaseStudyNav from '../../../../Components/TechCaseStudyNav';
const externalLink = "https://www.ryangroup.org/";

// CaseStudySlider 
const CaseStudySlider = {
    dots: false,
    arrows: false,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 7000,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
    {
        breakpoint: 968,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        },
    },
    {
        breakpoint: 768,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        },
    },
    ],
};
// CaseStudySlider End

// Slider

const mainSlider ={
    dot: false,
    arrows:true,
    infinite:true,
    autoplay:true,
    autoplaySpeed: 7000,
    speed:700,
    slideToShow:3,
    slidesToScroll:1,
    responsive: [
        {
            breakpoint:768,
            settings:{
                arrow:false,
            }
        }
    ]
}

// Slider

//CaseStudy Data
const CaseStudyData = [
    {
        link: '#',
        image: ourwork1,
        titale: 'Brand led site for a Banking Solutions Firm',
        tags: [{ name: 'BFSI' },],
    },  
    {
        link: '#',
        image: ourwork2,
        titale: 'A dynamic website for India’s biggest truck company',
        tags: [
            { name: 'Automobile' },
        ],
    },  
    {
        link: '#',
        image: ourwork3,
        titale: 'Revamped Website for one of the India’s biggest institution',
        tags: [{ name: 'Education' },],

    },
  ];
//CaseStudy Data End

const Ryangroup = () => {


  return (
    <>
            <Helmet>
              <title>Ryan International School: 100+ Websites CMS Case Study</title>
              <link rel="canonical" href="https://www.agency09.in/about"/>
              <meta name="robots" content="index, follow"/> 
        
              <meta name="description" content="Streamlined digital presence for Ryan International School by managing 100+ websites and CMS, improving efficiency, scalability, and user experience"/>
              <meta property="og:title" content="Ryan International School: 100+ Websites CMS Case Study"/> 
              <meta property="og:description" content="Streamlined digital presence for Ryan International School by managing 100+ websites and CMS, improving efficiency, scalability, and user experience"/> 
              <meta property="og:image" content="https://www.agency09.in/agency09.png"/> 
              <meta property="og:type" content="website"/> 
        
        
              <meta name="twitter:card" content="summary"/> 
              <meta name="twitter:site" content="@AGENCY09"/> 
              <meta name="twitter:creator" content="@AGENCY09"/> 
              <meta name="twitter:url" content="https://www.agency09.in/about"/> 
              <meta name="twitter:description" content=" Streamlined digital presence for Ryan International School by managing 100+ websites and CMS, improving efficiency, scalability, and user experience"/> 
              <meta name="twitter:image" content="https://www.agency09.in/agency09.png"/> 
        
            </Helmet>

    <Header/>
    <div className="spacer"></div>


    <section className='cSsecMin'>
        <div className='container'>
            
            <div className='cSsecMinA flexBio'>

                <div className='cSsecMinBtn m0'>
                <Link to='/work/case-studies' className='backBtn'><span><IoArrowBackCircleOutline /> Case Study</span></Link>
                </div>

                <div className='cSsecMinHead m0'>
                    <h1 className='sizeH4'>Streamlining Digital Presence: 100+ Websites & CMS for Ryan International School</h1>
                </div>

                <div className='cSsecMinInfo m0'>
                    <img src={logo} loading='lazy' />
                    {/* <Link>Info <GoPlus /></Link> */}
                </div>

            </div>

            <div className='strokeB'>
                <SVGCurveLine/>
            </div>  


            <div className='cSsecMinB'>
                <div className='cSsecMinBRow'>
                    <div className='cSsecMinBCol'>
                        <h4>Overview</h4>
                        <p>We collaborated with Ryan Group to design and develop a comprehensive digital solution for Ryan International School. The project involved creating a main website and a powerful CMS dashboard to manage over 100 individual school websites under the Ryan Group umbrella. The aim was to provide a cohesive and efficient system for managing each school's online presence while maintaining consistency and ease of use.</p>
                    </div>


                    <div className='cSsecMinBCol'>
                        <h4>Industry</h4>
                        <p>Education</p>
                    </div>
                    <div className='cSsecMinBCol'>
                       <h4>Services</h4>
                       <ul>
                        <li>Web Design & Development</li>
                        <li>Content Management Systems</li>
                       </ul>
                    </div>

                    <div className='cSsecMinBCol'>
                       <h4>Objective</h4>
                       <p>To streamline the digital presence of Ryan International School by creating a centralized CMS and user-friendly websites for over 100 schools under the Ryan Group.</p>
                    </div>

                    <div className='cSsecMinBCol'>
                       <h4>Challenges</h4>
                       <ul>
                        <li>Managing the digital presence of over 100 schools while maintaining consistency across all sites.</li>
                        <li>Ensuring the CMS was robust enough to handle multiple websites but also easy for the admin team to use.</li>
                       </ul>
                    </div>

                    <div className='cSsecMinBCol'>
                       <h4>Approach</h4>
                       <ul>
                        <li>Implemented a robust user management system to ensure secure and efficient handling of user access and permissions across multiple websites.</li>
                        <li>Developed a user-friendly interface for creating and managing individual school pages, allowing for easy updates and customization.</li>
                        <li>Built a comprehensive CMS dashboard that enabled the admin team to oversee and manage content across all school websites efficiently.</li>
                       </ul>
                    </div>

                    <div className='cSsecMinBCol'>
                       <h4>Results</h4>
                       <ul>
                        <li>Successfully streamlined the digital management of over 100 school websites.</li>
                        <li>Enhanced consistency and ease of use across all Ryan International School websites.</li>
                        <li>Improved efficiency for the admin team in managing content and updates.</li>
                       </ul>
                    </div>

                    <div className='cSsecMinBCol'>
                       <h4>Year</h4>
                       <p>2023</p>
                    </div>

                </div>

            </div>


            <div className='cSsecMinC'>

                <div className='imgCol1 imgCol'>
                    <span><img src={ourwork1} loading='lazy' /></span>
                </div>

                

            </div>


<div className='mainslider'>
    <Slider {...mainSlider} className='clientelSlider slick-slider'>
    <div className='imgCol1 imgCol'>
                    <span><img src={ourwork2} loading='lazy' /></span>
                </div>

                <div className='imgCol1 imgCol'>
                    <span><img src={ourwork3} loading='lazy' /></span>
                </div>

                <div className='imgCol1 imgCol'>
                    <span><img src={ourwork4} loading='lazy' /></span>
                </div>

                <div className='imgCol1 imgCol'>
                    <span><img src={ourwork5} loading='lazy' /></span>
                </div>

                <div className='imgCol1 imgCol'>
                    <span><img src={ourwork6} loading='lazy' /></span>
                </div>

    </Slider>
</div>

        </div>
    </section>

{/* 
    <div className='container'>
    <div className='strokeB'>
              <SVGCurveLine />
    </div>
    </div>

    
    <section className='solutionsSecCaseStudy'>
            <div className='container'>

            <div className='Heading center HeadingIcon'>
                <h2 className='sizeH1 uppercase'>
                    <span className='iconSVG'><i className='iconF'><img src={starY} alt='Star Icon' /></i></span>
                    Related Work
                    <span className='iconSVG'><i className='iconF'><img src={starY} alt='Star Icon' /></i></span>
                </h2>
            </div>


            <div className='solutionsSecCaseStudyList'>

                <Slider {...CaseStudySlider} className='CaseStudySlider slick-slider'>
                    {CaseStudyData.map((CaseStudy, index) => (
                        <div key={index} className='item'>
                        <div className='CaseStudyCol'>
                            <Link to={CaseStudy.link}>
                                <div className='CaseStudyImg'><img src={CaseStudy.image}/></div>
                                <div className='CaseStudyTitale'>{CaseStudy.titale}</div>
                                <div className='textTag'><p>{CaseStudy.tag}
                                
                                {CaseStudy.tags.map((tag, index) => (
                                  <span key={index}>{tag.name}</span>
                                ))}
                                
                                </p></div>
                            </Link>
                        </div>
                        </div>
                    ))}
                </Slider>

            <div className='btnSpaceEx center'>     
                <Link to="/work/case-studies" className="btnDark fontM ripple-button"><span>View All</span></Link>
            </div>

            </div>

            </div>
        </section>   */}


<div className='btnSpaceEx center'><a href={externalLink} target="_blank" rel="noreferrer" className="btnDark fontM ripple-button"><span>Visit Site</span></a></div>
<CaseStudyNav visitLink={externalLink} />


    <Footer/>
    </>
  )
}

export default Ryangroup
